/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.16.0 (NJsonSchema v9.13.25.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { throwException, RegisterExternalBindingModel, UserModel } from '@/Generated/ParticaAPI';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
export interface IAccountToken {
    /**
     * Get token for local user..
     * @param user 
	 * @param password 
     * @return OK
     */
	getToken(user: string, password: string): Promise<any>;
}

export class AccountToken implements IAccountToken {
	private instance: AxiosInstance;
	private baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance ? instance : axios.create();
		this.baseUrl = baseUrl ? baseUrl : "";
	}

    /**
     * Get token for local account.
     * @param user 
	 * @param password 
     * @return OK
     */
	getToken(user: string, password: string): Promise<any> {
		let url_ = this.baseUrl + "/token";
		let content_ = "grant_type=password&";
		if (user === undefined || user === null)
			throw new Error("The parameter 'user' must be defined and cannot be null.");
		else
			content_ += "username=" + encodeURIComponent("" + user) + "&";
		if (password === undefined || password === null)
			throw new Error("The parameter 'password' must be defined and cannot be null.");
		else
			content_ += "password=" + encodeURIComponent("" + password);
		content_ = content_.replace(/[?&]$/, "");

		let options_ = <AxiosRequestConfig>{
			data: content_,
			method: "POST",
			url: url_,
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"Accept": "application/json"
			}
		};

		return this.instance.request(options_).then((_response: AxiosResponse) => {
			return this.processToken(_response);
		});
	}

	protected processToken(response: AxiosResponse): Promise<any> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && response.headers.forEach) {
			response.headers.forEach((v: any, k: any) => _headers[k] = v);
		};
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200 !== undefined ? resultData200 : <any>null;
			return result200;
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException("An unexpected server error occurred.", status, _responseText, _headers);
		}
		return Promise.resolve<any>(<any>null);
	}
}

